import { connect } from "react-redux";
import SimuladorRecebimento from "./simulador";

export default connect()(SimuladorRecebimento);
